import moment from 'moment';

const PEER_REVIEW_TIME = moment.duration(2, 'hours').asMilliseconds();
const PROGRAMMING_ASSIGNMENT_TIME = moment.duration(3, 'hours').asMilliseconds();
const LTI_TIME = moment.duration(1, 'hours').asMilliseconds();
const NOTEBOOK_TIME = moment.duration(1, 'hours').asMilliseconds();
const READING_TIME = moment.duration(10, 'minutes').asMilliseconds();
const DISCUSSION_PROMPT_TIME = moment.duration(5, 'minutes').asMilliseconds();
const GRADED_DISCUSSION_PROMPT_TIME = moment.duration(10, 'minutes').asMilliseconds();
const STAFF_GRADED_TIME = moment.duration(3, 'hours').asMilliseconds();
const TEAMMATE_REVIEW_TIME = moment.duration(30, 'minutes').asMilliseconds();
const WIDGET_TIME = moment.duration(15, 'minutes').asMilliseconds();
const DIALOGUE_TIME = moment.duration(15, 'minutes').asMilliseconds();
const WORKSPACE_TIME = moment.duration(2, 'hours').asMilliseconds();
const UNGRADED_LAB_TIME = moment.duration(1, 'hours').asMilliseconds();
const WISEFLOW_TIME = moment.duration(1, 'hours').asMilliseconds();

const exported = {
  closedPeer: PEER_REVIEW_TIME,
  gradedPeer: PEER_REVIEW_TIME,
  phasedPeer: PEER_REVIEW_TIME,
  peer: PEER_REVIEW_TIME,
  splitPeerReviewItem: PEER_REVIEW_TIME,
  gradedProgramming: PROGRAMMING_ASSIGNMENT_TIME,
  programming: PROGRAMMING_ASSIGNMENT_TIME,
  ungradedProgramming: PROGRAMMING_ASSIGNMENT_TIME,
  ungradedLti: LTI_TIME,
  gradedLti: LTI_TIME,
  notebook: NOTEBOOK_TIME,
  supplement: READING_TIME,
  discussionPrompt: DISCUSSION_PROMPT_TIME,
  gradedDiscussionPrompt: GRADED_DISCUSSION_PROMPT_TIME,
  staffGraded: STAFF_GRADED_TIME,
  ungradedAssignment: STAFF_GRADED_TIME,
  teammateReview: TEAMMATE_REVIEW_TIME,
  ungradedWidget: WIDGET_TIME,
  dialogue: DIALOGUE_TIME,
  workspaceLauncher: WORKSPACE_TIME,
  ungradedLab: UNGRADED_LAB_TIME,
  wiseFlow: WISEFLOW_TIME,
};

export default exported;

export const {
  closedPeer,
  gradedPeer,
  phasedPeer,
  peer,
  splitPeerReviewItem,
  gradedProgramming,
  programming,
  ungradedProgramming,
  ungradedLti,
  gradedLti,
  notebook,
  supplement,
  discussionPrompt,
  gradedDiscussionPrompt,
  staffGraded,
  teammateReview,
  ungradedWidget,
  dialogue,
  workspaceLauncher,
  wiseFlow,
} = exported;
